module.exports = "pegasus/assets/blocks/column-lp18-themelp1.png";